"use client";

import { useEffect } from "react";

import { useTheme } from "@/app/hooks/useTheme";

/**
 * Updates PWA theme-color meta tag based on app theme.
 * Runs client-side to sync with the app's theme system.
 */
export function ThemeColorMeta() {
  const { theme } = useTheme();

  useEffect(() => {
    // Define colors matching CSS variables
    const colors = {
      light: "#f2efec",
      dark: "#1a1a1a",
    };

    // Determine the actual color to use
    let color: string;
    if (theme === "system") {
      // For system, use system preference
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      color = prefersDark ? colors.dark : colors.light;
    } else {
      color = colors[theme];
    }

    // Update or create theme-color meta tag
    let metaTag = document.querySelector('meta[name="theme-color"]');
    if (metaTag) {
      metaTag.setAttribute("content", color);
    } else {
      metaTag = document.createElement("meta");
      metaTag.setAttribute("name", "theme-color");
      metaTag.setAttribute("content", color);
      document.head.appendChild(metaTag);
    }

    // Listen for system theme changes when in system mode
    if (theme === "system") {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      const handler = (e: MediaQueryListEvent) => {
        const newColor = e.matches ? colors.dark : colors.light;
        metaTag?.setAttribute("content", newColor);
      };

      mediaQuery.addEventListener("change", handler);
      return () => mediaQuery.removeEventListener("change", handler);
    }
  }, [theme]);

  return null;
}
